export const copy = {
	anonymizedField: 'ANONYMIZED',
	paymentMessage: (userId: number): string => `Inbetalning (${userId})`,
	withdrawStatement: 'MyBonus.com',
	withdrawalReview: {
		message: 'Din utbetalning är under granskning.',
		details: 'Du kommer bli notifierad när vi behandlat din utbetalning.',
	},
	ongoingWithdrawal: {
		message: 'Du har redan en pågående utbetalning.',
		details: 'Testa igen lite senare.',
	},
	deniedWithdrawal: {
		message: 'Din utbetalning godkändes inte.',
		details: 'Vänligen kontakta kundtjänst för mer information.',
	},
	noName: 'Namnlös',
	upTo: 'Upp till',
	personalCashbackShare: 'Personlig höjning',
	offerwallGate: {
		eyebrow: 'Så fungerar det',
		title: 'Identifiera dig för att öppna erbjudanden',
		description:
			'I erbjudanden hittar du kampanjer från våra partners. När du genomför ett erbjudande enligt villkoren kan du få en belöning kopplad till ditt konto.',
		steps: [
			{
				title: 'Läs igenom erbjudanden',
				text: 'När du har identifierat dig kan du se partnererbjudanden som är tillgängliga för ditt konto.',
			},
			{
				title: 'Följ villkoren',
				text: 'Läs instruktionerna i varje erbjudande och genomför det hos partnern för att kvalificera dig.',
			},
			{
				title: 'Få belöning',
				text: 'Belöningen registreras när partnern rapporterar genomförandet. Tid och villkor varierar mellan erbjudanden.',
			},
		],
		ctaReason: 'Bekräfta med BankID för att öppna erbjudanden.',
	},
	offerwallUnavailable: {
		eyebrow: 'Erbjudanden',
		title: 'Erbjudanden är inte tillgängliga just nu',
		description:
			'Det går inte att öppna erbjudanden för ditt konto just nu. Du kan fortfarande använda MyBonus som vanligt under tiden.',
	},
	audienceBuilder: {
		BOOL: {
			UNSET: 'Unset',
			TRUTHY: 'True',
			FALSY: 'False',
		},
		DATE: {
			UNSET: 'Unset',
			EQ: 'Equals',
			NEQ: 'Not equals',
			GT: 'After',
			GTE: 'After or on',
			LT: 'Before',
			LTE: 'Before or on',
			IN_THE_LAST: 'In the last',
			MORE_THAN: 'More than',
			INSIDE: 'Between',
			OUTSIDE: 'Not between',
		},
		NUMBER: {
			INSIDE: 'Between',
			OUTSIDE: 'Not between',
			UNSET: 'Unset',
			TRUTHY: 'Non-zero',
			FALSY: 'Zero or not set',
			EQ: 'Equals',
			NEQ: 'Not equals',
			GT: 'Greater than',
			GTE: 'Greater than or equal to',
			LT: 'Less than',
			LTE: 'Less than or equal to',
		},
		SELECT: {
			INCLUDES: 'Includes',
			EXCLUDES: 'Excludes',
		},
		TEXT: {
			UNSET: 'Unset',
			TRUTHY: 'Is set',
			STARTS_WITH: 'Starts with',
			ENDS_WITH: 'Ends with',
			CONTAINS: 'Contains',
			EQ: 'Equals',
			NEQ: 'Not equals',
		},
	},
};
